export default "__VITE_ASSET__CVqR9XL7__"